import FormikTextField from '@ui-components-3/compat/lib/components/FormikTextField'
import { Formik, FormikHelpers } from 'formik'

import TestIds from 'util/TestIds'
import useDocumentTitle from 'hooks/useDocumentTitle'
import EmailSchema from 'schemas/EmailSchema'
import EntryFormCard from '../EntryFormCard'
import { EmailValues } from 'pages/EntryPage/EntryPage'

export type EmailSceneProps = {
  email?: string | null
  onSubmit: (values: EmailValues, form: FormikHelpers<EmailValues>) => void
  onCreateAccount: () => void
}

const LoginEmailScene = (props: EmailSceneProps) => {
  const { email, onSubmit, onCreateAccount } = props

  useDocumentTitle('Login Email')
  return (
    <EntryFormCard
      prompt={'To get started, enter your school email or create an account.'}
      data-testid={TestIds.login.view.email}
    >
      <p className="typography-body pb-4 text-start text-neutral-600">All fields marked with asterisks are required*</p>
      <div className="flex flex-col gap-6">
        <Formik initialValues={{ email: email ?? '' }} validationSchema={EmailSchema} onSubmit={onSubmit}>
          {({ isValid, handleSubmit, values }) => {
            return (
              <form onSubmit={handleSubmit} className="flex flex-col items-center gap-6">
                <FormikTextField
                  fullWidth
                  schema={EmailSchema}
                  label="Email Address"
                  name="email"
                  autoComplete="email"
                  data-testid={TestIds.login.input.email}
                  placeholder={'Email Address'}
                />
                <button
                  className="btn btn-primary w-full"
                  data-testid={TestIds.login.button.continue}
                  disabled={!isValid || !values.email}
                  type="submit"
                >
                  Continue
                </button>
              </form>
            )
          }}
        </Formik>
        <p className="typography-body text-neutral-800">
          New to TimelyCare?{' '}
          <button
            type="button"
            className="text-link-primary text-primary cursor-pointer font-semibold"
            data-testid={TestIds.login.button.forgot}
            onClick={onCreateAccount}
          >
            Get registered
          </button>
        </p>
      </div>
    </EntryFormCard>
  )
}

export default LoginEmailScene
